<script>
import { merge } from '@/util/common';
export default {
  name: 'ATable',
  props: {
    maxHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columns() {
      // const columns = this.options.columns.map(item => (merge({ show: true }, item)));

      
      return this.options.columns.map(item => (merge({ show: true }, item)));
    }
  },
  data() {
    return {
      checkedColumn: [],
      showPopups: false,
      showFilter: true,
      tableConfig: {
        columns: [],
        showCheckbox: true,
        showIndex: false,
        showAction: true,
        actionWidth: 200
      }
    }
  },
  created() {
    this.tableConfig = merge({}, this.tableConfig, this.options || {});
  },
  methods: {
    handleSelect(selection) {
      this.$emit('selection-change', selection)
    },
    handleShow() {
      this.showPopups = !this.showPopups
      console.log('show')
    },
    handleClose() {
      this.showPopups = false;
    }
  },
  render() {
    let { tableConfig, handleSelect, data, showFilter, handleShow, handleClose, showPopups, checkedColumn, columns, height } = this;
    const vm = this;
    let tableColumns = null;
    const checkboxColumn = (
      <el-table-column
        type="selection"
        width="55"
        prop="address">
      </el-table-column>
    )
    // const checkboxColumn = {
    //   type: 'selection',
    //   fixed: 'left',
    //   width: 55
    // }
    // const indexColumn = {
    //   type: 'index',
    //   fixed: 'left',
    //   width: 55,
    //   label: '序号'
    // }
    const indexColumn = (
      <el-table-column
        type="index"
        fixed="left"
        width="55"
        label="序号">
      </el-table-column>
    )
    const actionColumn = (
      <el-table-column
        width={tableConfig.actionWidth}
        scopedSlots={{
          default: function (props) {
            return vm.$scopedSlots.default && vm.$scopedSlots.default(props)
          }
        }}
        label="操作">
      </el-table-column>
    )
    tableColumns = columns
      .filter(item => (item.show))
      .map(item => {
        const { width, prop, label, formatter, slot, ...rest } = item;
        return slot
          ? (
              <el-table-column
                { ...rest }
                key={item.id}
                prop={prop}
                width={width}
                scopedSlots={{
                  default: function (props) {
                    return vm.$scopedSlots[slot] && vm.$scopedSlots[slot](props)
                  }
                }}
                label={label}>
              </el-table-column>
            )
          : (
              <el-table-column
                { ...rest }
                formatter={formatter}
                key={item.id}
                prop={prop}
                width={width}
                label={label}>
              </el-table-column>
            )
      })
    const handleOpen = () => {
      this.checkedColumn = columns.filter(item => (item.show)).map(item => item.prop);
    }
    const handleChance = (values) => {
      console.log('selected data:', values)
      this.checkedColumn = values;
      console.log('selected data:', this.checkedColumn)
    }
    const isChecked = (id) => (checkedColumn.indexOf(id) > -1);
    const handleConfirm = () => {
      columns.forEach(item => {
        item.show = isChecked(item.prop)
      })
      handleClose();
    }

    if (tableConfig.showCheckbox) {
      tableColumns.unshift(checkboxColumn)
    }
    if (tableConfig.showIndex) {
      tableColumns.unshift(indexColumn)
    }
    if (tableConfig.showAction) {
      tableColumns.push(actionColumn)
    }
    return (
      <div class="dynamic-table">
        <transition name="el-fade-in-linear">
          { showFilter ? <div class="atable-filter"><el-button icon="el-icon-s-operation" size="mini" circle onClick={handleShow}></el-button></div>: null }
        </transition>
        <el-table
          data={data}
          onSelectionChange={handleSelect}
          height={height}
          border
          style="width: 100%">
          {
            tableColumns
          }
        </el-table>
        <el-dialog
          title="表格列"
          append-to-body
          modal-append-to-body
          visible={showPopups}
          onOpen={handleOpen}
          onClose={handleClose}
          width="600px">
          <div class="filter-group">
            <el-checkbox-group value={checkedColumn} onInput={(values) => handleChance(values)}>
              <el-row gutter={20}>
                {
                  tableConfig.columns.map(item => (<el-col span={6}><el-checkbox label={item.prop} key={item.id}>{item.label}</el-checkbox></el-col>))
                }
              </el-row>
            </el-checkbox-group>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" onClick={handleClose}>取 消</el-button>
            <el-button size="small" type="primary" onClick={handleConfirm}>确 定</el-button>
          </span>
        </el-dialog>
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
  .dynamic-table {
    position: relative;
    // display: inline-block;
    .atable-filter {
      margin-bottom: 10px;
      padding-right: 10px;
      text-align: right;
    }
  }
</style>